// Centralized UI/feature flags for the marketing site.
// Flip these booleans to enable/disable UI sections globally.

export const FEATURE_FLAGS = {
  showDiscountBar: false,
};


